// SSR-friendly composable.
// const { data, pending, error, refresh } = await useFetch('https://api.example.com/data')

// The recommended way of using useFetch is in a component setup function, plugin, and route middleware.
// It is a straightforward way to handle data fetching without re - fetching or duplicate network calls,
// and it is a shortcut of useAsyncData + $fetch.
import type { NitroFetchOptions } from 'nitropack'

export const useHttpApi = async <T = unknown>(
  url: string,
  options?: NitroFetchOptions<string>
) => {
  const isAbsoluteUrl = url.startsWith('http://') || url.startsWith('https://')
  const baseURL = isAbsoluteUrl ? undefined : useRouterStore().apiUrl

  if (!isAbsoluteUrl && !baseURL) throw new Error('API URL is not defined')

  const token = useAuthToken().getToken()
  const headers = {
    ...(token ? { Authorization: token } : {}),
    ...(options?.headers ?? {})
  }
  // NOTE: keep options type simple to avoid vue-tsc "excessive stack depth"
  // with Nuxt's typed $fetch route inference.
  return $fetch<T>(url, {
    ...(options as NitroFetchOptions<any> | undefined),
    baseURL,
    headers
  } as NitroFetchOptions<any>)
}
